import { render, staticRenderFns } from "./ComponentradioDetail.vue?vue&type=template&id=3ea7ffa0&"
import script from "./ComponentradioDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentradioDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports